var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { call, cancelled, put, select, takeEvery } from 'redux-saga/effects';
import { ExactaAPI } from '../../api/exactaapi';
import { createAddRequest, createSetActions, createSingleUpdateRequest, createSingleUpdateRequestEmbedded } from '../../helpers/request';
import { apiCancelled_AC } from '../actions/api';
import { notifyError, notifySuccess } from '../actions/notification';
import { editProcess_AC, editProcessSuccess_AC, setProcessData_AC, types as processActionTypes, setSearchProcessIds_AC, searchProcessIds_AC, } from '../actions/process';
import { WebSocketRequest } from '../utils/constants';
import { takeLatestWithPayload } from '../utils/saga';
var searchProcessSaga = function (_a) {
    var cancelSource, exactaApi_1, queries, modelAlias, searchID, fetchAllIds, request, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                cancelSource = axios.CancelToken.source();
                _c.label = 1;
            case 1:
                _c.trys.push([1, , 8, 13]);
                console.log({ payload: payload, type: type });
                exactaApi_1 = ExactaAPI.getInstance();
                queries = payload.queries, modelAlias = payload.modelAlias, searchID = payload.searchID, fetchAllIds = payload.fetchAllIds;
                request = queries.map(function (query) { return (__assign({ version: exactaApi_1.getApiVersion(), type: 'searchResult', includeFinal: true }, query)); });
                console.log('[Process search request]', request);
                return [4, call(exactaApi_1.get, request, {
                        cancelToken: cancelSource.token,
                    })];
            case 2:
                _b = _c.sent(), response = _b.response, error = _b.error;
                if (!response) return [3, 6];
                return [4, put(setProcessData_AC(modelAlias, response.data, searchID))];
            case 3:
                _c.sent();
                if (!fetchAllIds) return [3, 5];
                return [4, put(searchProcessIds_AC(modelAlias, queries, searchID))];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3, 7];
            case 6:
                if (error) {
                    notifyError({
                        title: "Error",
                        message: "" + error,
                    });
                }
                _c.label = 7;
            case 7: return [3, 13];
            case 8: return [4, cancelled()];
            case 9:
                if (!_c.sent()) return [3, 12];
                return [4, call(cancelSource.cancel)];
            case 10:
                _c.sent();
                return [4, put(apiCancelled_AC())];
            case 11:
                _c.sent();
                _c.label = 12;
            case 12: return [7];
            case 13: return [2];
        }
    });
};
var searchProcessIdsSaga = function (_a) {
    var cancelSource, exactaApi_2, queries, modelAlias, searchID, request, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                cancelSource = axios.CancelToken.source();
                _c.label = 1;
            case 1:
                _c.trys.push([1, , 6, 11]);
                exactaApi_2 = ExactaAPI.getInstance();
                queries = payload.queries, modelAlias = payload.modelAlias, searchID = payload.searchID;
                request = queries.map(function (query) {
                    delete query.page;
                    return __assign(__assign({ version: exactaApi_2.getApiVersion(), type: 'searchResult' }, query), { allResults: true, idsOnly: true });
                });
                console.log('[Process Ids search request]', request);
                return [4, call(exactaApi_2.get, request, {
                        cancelToken: cancelSource.token,
                    })];
            case 2:
                _b = _c.sent(), response = _b.response, error = _b.error;
                if (!response) return [3, 4];
                return [4, put(setSearchProcessIds_AC(modelAlias, response.data, searchID))];
            case 3:
                _c.sent();
                return [3, 5];
            case 4:
                if (error) {
                    notifyError({
                        title: "Error",
                        message: "" + error,
                    });
                }
                _c.label = 5;
            case 5: return [3, 11];
            case 6: return [4, cancelled()];
            case 7:
                if (!_c.sent()) return [3, 10];
                return [4, call(cancelSource.cancel)];
            case 8:
                _c.sent();
                return [4, put(apiCancelled_AC())];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [7];
            case 11: return [2];
        }
    });
};
export var editProcessSaga = function (_a) {
    var requests, callback, exactaApi, apiVersion, _b, response, error, errorInResponse;
    var payload = _a.payload, type = _a.type;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                console.log({ payload: payload, type: type });
                requests = payload.requests, callback = payload.callback;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                return [4, call(exactaApi.execute, requests)];
            case 1:
                _b = _d.sent(), response = _b.response, error = _b.error;
                if (!response) return [3, 5];
                errorInResponse = getErrorInResponseIfExists(response);
                if (!(((_c = errorInResponse) === null || _c === void 0 ? void 0 : _c.length) > 0)) return [3, 2];
                notifyError({ title: 'Error', message: errorInResponse.join(',') });
                return [3, 4];
            case 2:
                callback && callback(response.data);
                return [4, put(editProcessSuccess_AC(response.data, apiVersion))];
            case 3:
                _d.sent();
                notifySuccess({
                    title: 'Success',
                    message: 'Operation executed successfully',
                });
                _d.label = 4;
            case 4: return [3, 6];
            case 5:
                if (error) {
                    notifyError({
                        title: "Error",
                        message: "" + error,
                    });
                    callback && callback(undefined, error);
                }
                _d.label = 6;
            case 6: return [2];
        }
    });
};
export var addNewProcessSaga = function (_a) {
    var modelAlias, values, executeAlias, exactaApi, apiVersion, actions, request;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                modelAlias = payload.modelAlias, values = payload.values, executeAlias = payload.executeAlias;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                actions = createAddRequest(values, executeAlias);
                request = [
                    {
                        modelAlias: modelAlias,
                        version: apiVersion,
                        subscribe: false,
                        actions: actions,
                    },
                ];
                return [4, put(editProcess_AC(request))];
            case 1:
                _b.sent();
                return [2];
        }
    });
};
export var addEmbeddedProcessSaga = function (_a) {
    var id, values, embeddedProcessAlias, executeAlias, actions, exactaApi, requests, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                id = payload.id, values = payload.values, embeddedProcessAlias = payload.embeddedProcessAlias, executeAlias = payload.executeAlias;
                actions = createAddRequest(values, executeAlias);
                exactaApi = ExactaAPI.getInstance();
                requests = [
                    {
                        version: exactaApi.getApiVersion(),
                        id: id,
                        subscribe: false,
                        actions: [
                            {
                                type: 'embedded',
                                value: {
                                    type: 'create',
                                    path: embeddedProcessAlias,
                                    actions: actions,
                                },
                            },
                        ],
                    },
                ];
                return [4, call(exactaApi.execute, requests)];
            case 1:
                _b = _c.sent(), response = _b.response, error = _b.error;
                if (response) {
                    console.log('success', { response: response });
                    notifySuccess({ title: 'Success', message: 'Embedded process success' });
                }
                else if (error) {
                    notifyError({
                        title: 'Error',
                        message: 'Embedded process creation failed',
                    });
                    console.log('error', { error: error });
                }
                return [2];
        }
    });
};
export var addEmbeddedDocumentProcessSaga = function (_a) {
    var id, values, embeddedProcessAlias, executeAlias, document, documentAlias, actions, exactaApi, formData, requests, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                id = payload.id, values = payload.values, embeddedProcessAlias = payload.embeddedProcessAlias, executeAlias = payload.executeAlias, document = payload.document, documentAlias = payload.documentAlias;
                actions = createAddRequest(values, executeAlias);
                exactaApi = ExactaAPI.getInstance();
                formData = new FormData();
                requests = [
                    {
                        id: id,
                        subscribe: false,
                        actions: [
                            {
                                type: 'embedded',
                                value: {
                                    type: 'create',
                                    path: embeddedProcessAlias,
                                    actions: actions,
                                },
                            },
                        ],
                    },
                ];
                if (Array.isArray(documentAlias)) {
                    documentAlias.forEach(function (docAlias, index) {
                        actions.splice(actions.length - 1 + index, 0, {
                            type: 'set',
                            alias: docAlias,
                            value: docAlias,
                        });
                        formData.append(docAlias, document[docAlias]);
                    });
                }
                else {
                    actions.splice(actions.length - 1, 0, {
                        type: 'set',
                        alias: documentAlias,
                        value: documentAlias,
                    });
                    formData.append(documentAlias, document);
                }
                formData.append('json', JSON.stringify({ requests: requests }));
                return [4, call(exactaApi.execute, formData, true)];
            case 1:
                _b = _c.sent(), response = _b.response, error = _b.error;
                if (response) {
                    console.log('success', { response: response });
                    notifySuccess({ title: 'Success', message: 'Embedded process success' });
                }
                else if (error) {
                    notifyError({
                        title: 'Error',
                        message: 'Embedded process creation failed',
                    });
                    console.log('error', { error: error });
                }
                return [2];
        }
    });
};
export var addNewDocumentProcessSaga = function (_a) {
    var modelAlias, values, executeAlias, document, documentAlias, formData, actions, exactaApi, apiVersion, requests, _b, response, error, errorInResponse;
    var payload = _a.payload, type = _a.type;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                modelAlias = payload.modelAlias, values = payload.values, executeAlias = payload.executeAlias, document = payload.document, documentAlias = payload.documentAlias;
                formData = new FormData();
                actions = createAddRequest(values, executeAlias);
                if (Array.isArray(documentAlias)) {
                    documentAlias.forEach(function (docAlias, index) {
                        actions.splice(actions.length - 1 + index, 0, {
                            type: 'set',
                            alias: docAlias,
                            value: docAlias,
                        });
                        formData.append(docAlias, document[docAlias]);
                    });
                }
                else {
                    actions.splice(actions.length - 1, 0, {
                        type: 'set',
                        alias: documentAlias,
                        value: documentAlias,
                    });
                    formData.append(documentAlias, document);
                }
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                requests = [
                    {
                        version: apiVersion,
                        modelAlias: modelAlias,
                        subscribe: false,
                        actions: actions,
                    },
                ];
                formData.append('json', JSON.stringify({ requests: requests }));
                return [4, call(exactaApi.execute, formData, true)];
            case 1:
                _b = _d.sent(), response = _b.response, error = _b.error;
                console.log({ response: response, error: error });
                if (!error) return [3, 2];
                notifyError({ title: 'Error', message: 'Something went wrong' });
                return [3, 5];
            case 2:
                errorInResponse = getErrorInResponseIfExists(response);
                if (!(((_c = errorInResponse) === null || _c === void 0 ? void 0 : _c.length) > 0)) return [3, 3];
                notifyError({ title: 'Error', message: errorInResponse.join(',') });
                return [3, 5];
            case 3: return [4, put(editProcessSuccess_AC(response.data, apiVersion))];
            case 4:
                _d.sent();
                notifySuccess({
                    title: 'Success',
                    message: 'Operation performed successfully',
                });
                _d.label = 5;
            case 5: return [2];
        }
    });
};
var getErrorInResponseIfExists = function (response) {
    var _a;
    var data = response.data;
    return (_a = data.requests
        .filter(function (req) { return req.status === 'error'; })
        .map(function (req) {
        var _a, _b;
        return (_b = (_a = req.error) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.message;
    }), (_a !== null && _a !== void 0 ? _a : []));
};
export var updateDocumentProcessSaga = function (_a) {
    var id, document, documentAlias, apiVersion, request, formData, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                id = payload.id, document = payload.document, documentAlias = payload.documentAlias;
                apiVersion = ExactaAPI.getInstance().getApiVersion();
                request = createSingleUpdateRequest(documentAlias, id, documentAlias);
                formData = new FormData();
                formData.append('json', JSON.stringify({ requests: [request] }));
                formData.append(documentAlias, document);
                return [4, call(ExactaAPI.getInstance().execute, formData, true)];
            case 1:
                _b = _c.sent(), response = _b.response, error = _b.error;
                if (error) {
                    notifyError({
                        title: 'Something went wrong',
                        message: 'Please verify the changes and submit again',
                    });
                }
                else {
                    notifySuccess({
                        title: 'Success',
                        message: 'Document updated successfully',
                    });
                }
                console.log({ response: response, error: error });
                return [4, put(editProcessSuccess_AC(response.data, apiVersion))];
            case 2:
                _c.sent();
                return [2];
        }
    });
};
export var updateEmbeddedProcessDocumentSaga = function (_a) {
    var id, document, documentAlias, path, formData, exactaApi, request, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                id = payload.id, document = payload.document, documentAlias = payload.documentAlias, path = payload.path;
                formData = new FormData();
                exactaApi = ExactaAPI.getInstance();
                request = {
                    version: exactaApi.getApiVersion(),
                    id: id,
                    subscribe: false,
                    actions: [
                        {
                            type: 'embedded',
                            value: {
                                type: 'edit',
                                path: path,
                                actions: [
                                    {
                                        type: 'set',
                                        alias: documentAlias,
                                        value: documentAlias,
                                    },
                                ],
                            },
                        },
                    ],
                };
                formData.append('json', JSON.stringify({ requests: [request] }));
                formData.append(documentAlias, document);
                return [4, call(exactaApi.execute, formData, true)];
            case 1:
                _b = _c.sent(), response = _b.response, error = _b.error;
                console.log({ response: response, error: error });
                if (error) {
                    notifyError({
                        title: 'Something went wrong',
                        message: 'Please verify the changes and submit again',
                    });
                }
                else {
                    notifySuccess({
                        title: 'Success',
                        message: 'Updated successfully',
                    });
                }
                return [2];
        }
    });
};
export var updateEmbeddedProcess = function (_a) {
    var id, alias, value, embeddedPath, body, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                id = payload.id, alias = payload.alias, value = payload.value, embeddedPath = payload.embeddedPath;
                body = createSingleUpdateRequestEmbedded(alias, id, value, embeddedPath);
                return [4, put(editProcess_AC([body]))];
            case 1:
                _b = _c.sent(), response = _b.response, error = _b.error;
                console.log({ response: response, error: error });
                if (error) {
                    notifyError({
                        title: 'Something went wrong',
                        message: 'Please verify the changes and submit again',
                    });
                }
                else {
                    notifySuccess({
                        title: 'Success',
                        message: 'Updated successfully',
                    });
                }
                return [2];
        }
    });
};
export var moveProcessSaga = function (_a) {
    var id, executeAlias, callback, exactaApi, apiVersion, requests, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                id = payload.id, executeAlias = payload.executeAlias, callback = payload.callback;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                requests = [
                    {
                        type: 'edit',
                        version: apiVersion,
                        subscribe: false,
                        id: id,
                        actions: [
                            {
                                type: 'execute',
                                alias: executeAlias,
                            },
                        ],
                    },
                ];
                return [4, call(exactaApi.execute, requests)];
            case 1:
                _b = _c.sent(), response = _b.response, error = _b.error;
                if (!response) return [3, 3];
                callback && callback(response.data);
                return [4, put(editProcessSuccess_AC(response.data, apiVersion))];
            case 2:
                _c.sent();
                return [3, 4];
            case 3:
                if (error) {
                    callback && callback(undefined, error);
                }
                _c.label = 4;
            case 4: return [2];
        }
    });
};
export var moveEmbeddedProcessSaga = function (_a) {
    var id, executeAlias, callback, path, exactaApi, apiVersion, requests, _b, response, error;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                id = payload.id, executeAlias = payload.executeAlias, callback = payload.callback, path = payload.path;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                requests = [
                    {
                        id: id,
                        version: apiVersion,
                        actions: [
                            {
                                type: 'embedded',
                                value: {
                                    type: 'edit',
                                    path: path,
                                    actions: [
                                        {
                                            type: 'execute',
                                            alias: executeAlias,
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ];
                return [4, call(exactaApi.execute, requests)];
            case 1:
                _b = _c.sent(), response = _b.response, error = _b.error;
                if (!response) return [3, 3];
                callback && callback(response.data);
                return [4, put(editProcessSuccess_AC(response.data, apiVersion))];
            case 2:
                _c.sent();
                return [3, 4];
            case 3:
                if (error) {
                    callback && callback(undefined, error);
                }
                _c.label = 4;
            case 4: return [2];
        }
    });
};
export var getUpdatedProcessSaga = function (_a) {
    var cancelSource, id, exactaApi, apiVersion, requestIds, requests, response;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cancelSource = axios.CancelToken.source();
                _b.label = 1;
            case 1:
                _b.trys.push([1, , 5, 10]);
                id = payload.id;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                return [4, shouldProceedWithRequest(payload, [id])];
            case 2:
                requestIds = _b.sent();
                if (!requestIds) {
                    return [2];
                }
                requests = [
                    {
                        type: 'processInstance',
                        version: apiVersion,
                        id: requestIds[0],
                        subscribe: false,
                        history: false,
                    },
                ];
                return [4, call(exactaApi.get, requests, {
                        cancelToken: cancelSource.token,
                    })];
            case 3:
                response = (_b.sent()).response;
                return [4, put(editProcessSuccess_AC({ requests: response.data.data }, apiVersion))];
            case 4:
                _b.sent();
                return [3, 10];
            case 5: return [4, cancelled()];
            case 6:
                if (!_b.sent()) return [3, 9];
                return [4, call(cancelSource.cancel)];
            case 7:
                _b.sent();
                return [4, put(apiCancelled_AC())];
            case 8:
                _b.sent();
                _b.label = 9;
            case 9: return [7];
            case 10: return [2];
        }
    });
};
var shouldProceedWithRequest = function (payload, ids) {
    var subData, subscriptions, requestsToBeMade;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (payload[Symbol.for(WebSocketRequest)]) {
                    return [2, ids];
                }
                return [4, select(function (state) { return state.websocket.data; })];
            case 1:
                subData = _c.sent();
                subscriptions = (_b = (_a = subData) === null || _a === void 0 ? void 0 : _a.subscriptions, (_b !== null && _b !== void 0 ? _b : []));
                requestsToBeMade = ids.filter(function (id) {
                    return !subscriptions.find(function (subId) { return subId === id; });
                });
                if (requestsToBeMade.length > 0) {
                    return [2, requestsToBeMade];
                }
                return [4, put(apiCancelled_AC())];
            case 2:
                _c.sent();
                return [2, false];
        }
    });
};
export var getUpdatedProcessesSaga = function (_a) {
    var ids, exactaApi, apiVersion, requestIds, requests, response;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                ids = payload.ids;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                return [4, shouldProceedWithRequest(payload, ids)];
            case 1:
                requestIds = _b.sent();
                if (!requestIds) {
                    return [2];
                }
                requests = [
                    {
                        type: 'processInstance',
                        version: apiVersion,
                        ids: requestIds,
                        subscribe: false,
                        history: false,
                    },
                ];
                return [4, call(exactaApi.get, requests)];
            case 2:
                response = (_b.sent()).response;
                return [4, put(editProcessSuccess_AC({ requests: response.data.data[0] }, apiVersion))];
            case 3:
                _b.sent();
                return [2];
        }
    });
};
export var addProcessWithEmbedded = function (_a) {
    var modelAlias, values, embeddedProcessValues, embeddedPath, actions, request;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                modelAlias = payload.modelAlias, values = payload.values, embeddedProcessValues = payload.embeddedProcessValues, embeddedPath = payload.embeddedPath;
                actions = createSetActions(values);
                actions.push({
                    type: 'embedded',
                    value: {
                        type: 'create',
                        path: embeddedPath,
                        actions: createSetActions(embeddedProcessValues),
                    },
                });
                request = [
                    {
                        modelAlias: modelAlias,
                        subscribe: false,
                        actions: actions,
                    },
                ];
                return [4, put(editProcess_AC(request))];
            case 1:
                _b.sent();
                return [2];
        }
    });
};
var actionWatcher = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, takeLatestWithPayload(processActionTypes.GET_UPDATED_PROCESSES, getUpdatedProcessesSaga)];
            case 1:
                _a.sent();
                return [4, takeLatestWithPayload(processActionTypes.SEARCH_PROCESS_DATA, searchProcessSaga)];
            case 2:
                _a.sent();
                return [4, takeLatestWithPayload(processActionTypes.SEARCH_PROCESS_IDS, searchProcessIdsSaga)];
            case 3:
                _a.sent();
                return [4, takeEvery(processActionTypes.EDIT_PROCESS_DATA, editProcessSaga)];
            case 4:
                _a.sent();
                return [4, takeEvery(processActionTypes.ADD_NEW_PROCESS, addNewProcessSaga)];
            case 5:
                _a.sent();
                return [4, takeEvery(processActionTypes.MOVE_PROCESS, moveProcessSaga)];
            case 6:
                _a.sent();
                return [4, takeEvery(processActionTypes.MOVE_EMBEDDED_PROCESS, moveEmbeddedProcessSaga)];
            case 7:
                _a.sent();
                return [4, takeLatestWithPayload(processActionTypes.GET_UPDATED_PROCESS, getUpdatedProcessSaga)];
            case 8:
                _a.sent();
                return [4, takeEvery(processActionTypes.ADD_NEW_DOCUMENT_PROCESS, addNewDocumentProcessSaga)];
            case 9:
                _a.sent();
                return [4, takeEvery(processActionTypes.UPDATE_DOCUMENT_PROCESS, updateDocumentProcessSaga)];
            case 10:
                _a.sent();
                return [4, takeEvery(processActionTypes.ADD_EMBEDDED_PROCESS, addEmbeddedProcessSaga)];
            case 11:
                _a.sent();
                return [4, takeEvery(processActionTypes.UPDATE_EMBEDDED_PROCESS_DOCUMENT, updateEmbeddedProcessDocumentSaga)];
            case 12:
                _a.sent();
                return [4, takeEvery(processActionTypes.ADD_DOCUMENT_EMBEDDED_PROCESS, addEmbeddedDocumentProcessSaga)];
            case 13:
                _a.sent();
                return [4, takeEvery(processActionTypes.ADD_PROCESS_WITH_EMBEDDED, addProcessWithEmbedded)];
            case 14:
                _a.sent();
                return [4, takeEvery(processActionTypes.UPDATE_EMBEDDED_PROCESS, updateEmbeddedProcess)];
            case 15:
                _a.sent();
                return [2];
        }
    });
};
export default actionWatcher;
//# sourceMappingURL=process.js.map